// <head> metadata for DbosTransactPage (https://www.dbos.dev/dbos-transact).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'DBOS Transact | Open Source Durable Execution Library',
    },
    {
      name: 'description',
      content:
        'DBOS Transact is an open source durable execution library for reliable Python, TypeScript, Go, Java and Rust backends. Develop locally, deploy anywhere.',
    },
    {
      property: 'og:title',
      content: 'DBOS Transact | Open Source Durable Execution Library',
    },
    {
      property: 'og:description',
      content:
        'DBOS Transact is an open source durable execution library for reliable Python, TypeScript, Go, Java and Rust backends. Develop locally, deploy anywhere.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/675bb12fcea5598fbbb14f86_DBOS-Transact-Website-OG.jpg',
    },
    {
      name: 'twitter:title',
      content: 'DBOS Transact | Open Source Durable Execution Library',
    },
    {
      name: 'twitter:description',
      content:
        'DBOS Transact is an open source durable execution library for reliable Python, TypeScript, Go, Java and Rust backends. Develop locally, deploy anywhere.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/675bb12fcea5598fbbb14f86_DBOS-Transact-Website-OG.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/dbos-transact',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
